import type { Order } from "../types/order";
import type { StandbyOrder } from "../types/standbyOrder";

export type OrderListRow =
  | { kind: "trip"; _id: string; order: Order }
  | { kind: "standby"; _id: string; order: StandbyOrder };

const rowSortKey = (row: OrderListRow): string => {
  if (row.kind === "trip") {
    return row.order.departureTimestamp || row.order.readableId;
  }
  return row.order.date || row.order.readableId;
};

export const mergeOrderListRows = (
  orders: Order[],
  standbyOrders: StandbyOrder[],
): OrderListRow[] => {
  return [
    ...orders.map((order): OrderListRow => ({ kind: "trip", _id: order._id, order })),
    ...standbyOrders.map((order): OrderListRow => ({ kind: "standby", _id: order._id, order })),
  ].sort((left, right) => rowSortKey(right).localeCompare(rowSortKey(left)));
};
